<template>

<fragment>

    <com-numeric v-if="(type.type === 'numeric' && !force) || force === 'numeric'" :rule="rule" :value="value" v-on:input="$emit('input', $event)" :type="type" />

    <com-date v-if="(type.type === 'date' && !force) || force === 'date'" :wrapper="$refs.wrapper" :rule="rule" :value="value" v-on:input="$emit('input', $event)" :type="type" />

    <com-select v-if="(type.type === 'category' && !force) || force === 'category'" :rule="rule" :value="value" v-on:input="$emit('input', $event)" :type="type" />

    <com-toggle v-if="(type.type === 'toggle' && !force) || force === 'toggle'" :rule="rule" :value="value" v-on:input="$emit('input', $event)" :type="type" />

    <com-set v-if="(type.type === 'set' && !force) || force === 'toggle'" :rule="rule" :value="value" v-on:input="$emit('input', $event)" :type="type" />

    <com-text v-if="(type.type === 'text' && !force) || force === 'text'" :rule="rule" :value="value" v-on:input="$emit('input', $event)" :type="type" />

</fragment>

</template>

<script>

import comNumeric from './Input_Numeric'
import comDate from './Input_Date'
import comSelect from './Input_Select'
import comToggle from './Input_Toggle'
import comSet from './Input_Set'
import comText from './Input_Text'

export default {

    props: ['value', 'force', 'type', 'rule'],

    components: {
        'com-numeric': comNumeric,
        'com-date': comDate,
        'com-select': comSelect,
        'com-toggle': comToggle,
        'com-set': comSet,
        'com-text': comText
    }

}

</script>

<style scoped>

</style>